/**
 * Explicitly tear down iframes before clearing a container.
 *
 * Setting src to 'about:blank' forces WebKit to release the browsing
 * context (Window, NativeContext, prototype caches) synchronously instead
 * of deferring it to GC.  On Mobile Safari the deferred contexts accumulate
 * and push the process past the ~1.5 GB jetsam limit, crashing the tab.
 */
export function clearContainer(container: HTMLElement) {
  const iframes = container.querySelectorAll('iframe')
  for (let i = 0; i < iframes.length; i++) {
    try { iframes[i].src = 'about:blank' } catch (e) { /* cross-origin */ }
    iframes[i].remove()
  }
  container.innerHTML = ''
}
